import { put, takeEvery, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { push } from "connected-react-router";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";

function* login(cred) {
  try {
    const loginData = {
      username: cred.cred.username,
      password: cred.cred.password,
    };
    const res = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/user/login`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      }
    );

    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_LOGIN_SUCCESS_ACTION,
        payload: resJSON,
      });
      localStorage.setItem("fmsToken", resJSON.access_token);
      yield call(fetchSocprofile, resJSON);
    }
  } catch (err) {
    if (err.status === 401) {
      yield toast.error("Invalid username", {
        autoClose: 3000,
        position: "top-right",
      });
    } else {
      yield toast.error("Login failed", {
        autoClose: 3000,
        position: "top-right",
      });
    }
    yield put({
      type: actionTypes.FETCH_LOGIN_FAIL_ACTION,
      payload: err,
    });
  }
}

function* fetchSocprofile(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const data = {
      societyId: value.society_id,
    };
    const res = yield fetch(
      appConfig.urlPrefixIp + "/societydataservice/society/profile",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      if (resJSON.response_data.blockPortal == 1) {
        yield put(push("/suspended"));
      } else if (resJSON.response_data.status == "installation") {
        localStorage.setItem("FmsUser", JSON.stringify(value));
        localStorage.setItem(
          "fmsProfDetail",
          JSON.stringify(resJSON.response_data)
        );
        let baccess = localStorage.getItem("baccess");
        if (baccess == "yes") {
          yield put(push("/suspended"));
        } else {
          yield put(push("/onboardingResidents"));
        }
      } else {
        localStorage.setItem("FmsUser", JSON.stringify(value));
        localStorage.setItem(
          "fmsProfDetail",
          JSON.stringify(resJSON.response_data)
        );
        yield put(push("/dashboard"));
        yield call(fetchRwaStatus, value.society_id);
        yield toast.success("Logged in successfully", {
          autoClose: 3000,
        });
      }
    }
  } catch (err) {}
}

function* fetchRwaStatus(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const data = {
      societyId: value,
    };
    const res = yield fetch(
      appConfig.urlPrefixIp + "/apartmentinfoservice/society/getrwastatus",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      localStorage.setItem("rwastatus", resJSON.response_data.status);
    }
  } catch (err) {}
}

function* logOut() {
  localStorage.removeItem("fmsToken");
  localStorage.removeItem("FmsUser");
  localStorage.removeItem("fmsProfDetail");
  localStorage.removeItem("selectedItemData");
  localStorage.removeItem("baccess");
  localStorage.removeItem("totalConsumption");
  localStorage.removeItem("TotalCollectedAmount");
  localStorage.removeItem("apartmentLength1");
  localStorage.removeItem("rwastatus");
}

export function* LoginActionWatcher() {
  yield takeEvery(actionTypes.LOGIN_INIT_ACTION, login);
  yield takeEvery(actionTypes.LOGOUT_ACTION, logOut);
}
